import angular from 'angular';

import SceneModule from './scene';

export default angular
    .module('application.scene.identity.scene.email-verification', [
        SceneModule.name
    ])
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('identity.email-verification', {
        url: '/verify-email',
        abstract: true,
        template: '<ui-view class="block-component"></ui-view>'
    });
}




// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/email-verification/index.js